"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyMakeCali = void 0;
const print_util_1 = require("client/modules/labels/print-labels/print-manager/print-util");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const moment = require("moment");
class PharmacyMakeCali extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
    }
    make() {
        var _a, _b, _c, _d, _e, _f, _g;
        const { claim, barcode, patientSignature, historic } = this.printMeta;
        const currentClaim = mobx_1.toJS(claim);
        const order = currentClaim.order;
        const inventoryItem = (_a = historic === null || historic === void 0 ? void 0 : historic.inventoryData) !== null && _a !== void 0 ? _a : currentClaim.inventory;
        const patient = (_b = historic === null || historic === void 0 ? void 0 : historic.patientData) !== null && _b !== void 0 ? _b : order.patient;
        const provider = (_c = historic === null || historic === void 0 ? void 0 : historic.providerData) !== null && _c !== void 0 ? _c : order.provider;
        const site = (_d = historic === null || historic === void 0 ? void 0 : historic.siteData) !== null && _d !== void 0 ? _d : order.site;
        const claimLots = currentClaim.claimLots;
        const originalOrder = currentClaim.originalOrder || null;
        const orderDate = originalOrder
            ? originalOrder.createDate
            : currentClaim.date;
        const user = (_e = historic === null || historic === void 0 ? void 0 : historic.userData) !== null && _e !== void 0 ? _e : store_1.usersStore.user.value;
        const claimDate = currentClaim.date;
        const pageBreak = this.lastPage ? "" : "after";
        return [
            {
                columns: [
                    {
                        style: "patientReceipt",
                        width: 110,
                        stack: [
                            {
                                style: "header",
                                text: `${site.name || ""}\n`,
                                bold: true,
                                margin: [0, 2, 0, 0]
                            },
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                text: `RX:`,
                                                bold: true
                                            },
                                            [
                                                {
                                                    text: `${currentClaim.rxId.rxId}-${currentClaim.fillNumber}`,
                                                    bold: true
                                                },
                                                {
                                                    text: `${patient.lastName ||
                                                        ""}, ${patient.firstName || ""}`,
                                                    bold: true
                                                },
                                                {
                                                    text: `${patient.address || ""}, ${patient.city ||
                                                        ""}, ${patient.state} ${patient.zip || ""}`,
                                                    fontSize: 4
                                                }
                                            ]
                                        ]
                                    ],
                                    style: { border: 0 }
                                },
                                layout: "noBorders"
                            },
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                text: [
                                                    { text: `Phone: `, fontSize: 5, bold: true },
                                                    {
                                                        text: `${patient.phoneNumber || "(000) 000-0000"}`,
                                                        fontSize: 5,
                                                        margin: [0, -5, 0, 0]
                                                    }
                                                ]
                                            },
                                            {
                                                text: [
                                                    {
                                                        text: "DOB: ",
                                                        fontSize: 5,
                                                        margin: [0, -5, 0, 0],
                                                        bold: true
                                                    },
                                                    {
                                                        text: `${patient.birthDate || "  /  /    "}`,
                                                        fontSize: 5,
                                                        margin: [0, -5, 0, 0]
                                                    }
                                                ]
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                // text: `Drug: ${inventoryItem.name}`,
                                                text: `Drug: ${inventoryItem.name}`,
                                                fontSize: 5,
                                                bold: true
                                            }
                                        ],
                                        [
                                            {
                                                text: [
                                                    { text: "Manufacturer: ", fontSize: 5, bold: true },
                                                    {
                                                        text: `${inventoryItem.labeler}`,
                                                        fontSize: 5
                                                    }
                                                ],
                                                margin: [0, -4, 0, 0]
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                table: {
                                    widths: [20, 50, "*"],
                                    body: [
                                        [
                                            {
                                                text: [
                                                    { text: "QTY: ", fontSize: 5, bold: true },
                                                    {
                                                        text: `${currentClaim.quantity *
                                                            inventoryItem.disQty || "N/A"}`,
                                                        fontSize: 5
                                                    },
                                                    { text: `\n` },
                                                    { text: "DAW: ", fontSize: 5, bold: true },
                                                    { text: "0", fontSize: 5 }
                                                ],
                                                margin: [0, -2, 0, 0]
                                            },
                                            {
                                                text: [
                                                    { text: "Refills: ", fontSize: 5, bold: true },
                                                    { text: `${claim.refills || "N/A"}`, fontSize: 5 },
                                                    { text: `\n` },
                                                    { text: "NDC: ", fontSize: 5, bold: true },
                                                    {
                                                        text: `${inventoryItem.package || "N/A"}`,
                                                        fontSize: 5
                                                    }
                                                ],
                                                margin: [-6, -2, 0, 0]
                                            },
                                            {
                                                table: {
                                                    widths: [20, 50],
                                                    body: [
                                                        [
                                                            {
                                                                text: "Lot/Exp: ",
                                                                fontSize: 5,
                                                                bold: true
                                                            },
                                                            {
                                                                text: `${(claimLots &&
                                                                    claimLots
                                                                        .map((claimLot) => "#" +
                                                                        claimLot.siteLot.lotNumber +
                                                                        " | " +
                                                                        String(moment(claimLot.siteLot.expirationDate).format("MM/DD/YY")) +
                                                                        "\n")
                                                                        .join("")) ||
                                                                    "N/A"}`,
                                                                fontSize: 4,
                                                                margin: [-6, 0, 0, 0]
                                                            }
                                                        ]
                                                    ]
                                                },
                                                margin: [-12, -4, 0, 0],
                                                layout: "noBorders"
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                text: [
                                                    {
                                                        text: `PRSCRBR:
                              DEA/LIC:
                              Employee Disp:`
                                                    }
                                                ],
                                                fontSize: 5,
                                                bold: true
                                            },
                                            {
                                                text: [
                                                    `${provider.lastName ||
                                                        "N/A"}, ${provider.firstName || "N/A"}
                            ${provider.dea}
                            ${user.firstName[0]}. ${user.lastName}`
                                                ],
                                                fontSize: 5
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders",
                                margin: [0, 0, 0, 0]
                            },
                            {
                                text: [
                                    `${site.address || "N/A"} ${currentClaim.order.site.city ||
                                        "N/A"}, ${site.state} ${site.zip || "N/A"} | ${currentClaim
                                        .order.site.phone || "(000) 000-0000"}`
                                ],
                                fontSize: 4,
                                margin: [0, -2, 0, 0]
                            },
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                text: [
                                                    { text: "DATE: ", fontSize: 5, bold: true },
                                                    {
                                                        text: `${moment(currentClaim.date).format("MM/DD/YYYY")}`,
                                                        fontSize: 5
                                                    }
                                                ],
                                                margin: [0, 0, 0, 0]
                                            },
                                            {
                                                text: [
                                                    { text: "COPAY: ", fontSize: 5, bold: true },
                                                    {
                                                        text: `$${(((_g = (_f = currentClaim.copay) === null || _f === void 0 ? void 0 : _f.newPatientAmount) !== null && _g !== void 0 ? _g : currentClaim.patientAmount) / 100).toFixed(2)}`,
                                                        fontSize: 5
                                                    }
                                                ],
                                                margin: [0, 0, 0, 0]
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                text: "SIG:",
                                                fontSize: 5,
                                                margin: [0, -3, 0, 0],
                                                bold: true
                                            },
                                            {
                                                text: `${(inventoryItem.defaultSig &&
                                                    inventoryItem.defaultSig) ||
                                                    "N/A"}${inventoryItem.defaultSig2 &&
                                                    " - " + inventoryItem.defaultSig2}${currentClaim
                                                    .inventory.defaultSig3 &&
                                                    " - " + inventoryItem.defaultSig3}
                        `,
                                                fontSize: 4,
                                                margin: [-3, -3, 0, 0]
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            }
                        ]
                    },
                    {
                        // width: 200,
                        layout: {
                            hLineWidth(i, node) {
                                return i === 0 || i === node.table.body.length ? 0 : 0;
                            },
                            vLineWidth(i, node) {
                                return i === 0 || i === node.table.widths.length ? 0 : 0;
                            },
                            paddingLeft(i, node) {
                                return 4;
                            },
                            paddingRight(i, node) {
                                return 4;
                            },
                            paddingTop(i, node) {
                                return 2;
                            },
                            paddingBottom(i, node) {
                                return 2;
                            }
                        },
                        style: "labelTableText",
                        table: {
                            margin: [200, 0, 0, 0],
                            heights: [35, 35, 35],
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 0,
                            widths: [105, 105],
                            body: [
                                [
                                    {
                                        text: `${(claim.inventory.warningLabel &&
                                            claim.inventory.warningLabel.labelOne) ||
                                            ""}`,
                                        margin: [15, 7, 0, 0]
                                    },
                                    {
                                        text: `${(claim.inventory.warningLabel &&
                                            claim.inventory.warningLabel.labelFour) ||
                                            ""}`,
                                        margin: [16, 7, 0, 0]
                                    }
                                ],
                                [
                                    {
                                        text: `${(claim.inventory.warningLabel &&
                                            claim.inventory.warningLabel.labelTwo) ||
                                            ""}`,
                                        margin: [15, 7, 0, 0]
                                    },
                                    {
                                        text: `${(claim.inventory.warningLabel &&
                                            claim.inventory.warningLabel.labelFive) ||
                                            ""}`,
                                        margin: [16, 7, 0, 0]
                                    }
                                ],
                                [
                                    {
                                        text: `${(claim.inventory.warningLabel &&
                                            claim.inventory.warningLabel.labelThree) ||
                                            ""}`,
                                        margin: [15, 9, 0, 0]
                                    },
                                    {
                                        text: `${(claim.inventory.warningLabel &&
                                            claim.inventory.warningLabel.labelSix) ||
                                            ""}`,
                                        margin: [16, 9, 0, 0]
                                    }
                                ]
                            ]
                        }
                    },
                    // To place an image within a column you must place it within a stack or else it will
                    // not render.
                    {
                        style: "rightColumn",
                        width: 160,
                        margin: [5, -30, -40, 0],
                        stack: [
                            {
                                table: {
                                    widths: ["*", "*"],
                                    body: [
                                        [
                                            {
                                                text: [
                                                    {
                                                        text: `${site.name} \n`,
                                                        style: "header",
                                                        bold: true
                                                    },
                                                    {
                                                        text: `${site.address || "N/A"} ${site.city ||
                                                            "N/A"}, ${site.state} ${site.zip || "N/A"} \n`,
                                                        fontSize: 4
                                                    },
                                                    {
                                                        text: ` ${site.phone || "(000) 000-0000"}`,
                                                        fontSize: 5,
                                                        bold: true
                                                    }
                                                ]
                                            },
                                            {
                                                text: [
                                                    {
                                                        text: `${patient.firstName} ${patient.lastName}\n`,
                                                        style: "header",
                                                        bold: true
                                                    }
                                                ]
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                text: `\n`
                            },
                            {
                                text: `RX Number: ${currentClaim.rxId.rxId}-${claim.fillNumber}`,
                                fontSize: 5,
                                bold: true
                            },
                            {
                                table: {
                                    widths: ["*", "*"],
                                    body: [
                                        [
                                            {
                                                text: [
                                                    {
                                                        text: `Date Filled: ${moment(currentClaim.date).format("MM/DD/YYYY")}\n`,
                                                        fontSize: 5
                                                    },
                                                    {
                                                        text: `Discard After: ${claimLots.length
                                                            ? moment(claimLots.reduce((pre, cur) => pre.siteLot.expirationDate <
                                                                cur.siteLot.expirationDate
                                                                ? pre
                                                                : cur).siteLot.expirationDate).format("MM/DD/YYYY")
                                                            : ""}\n`,
                                                        fontSize: 5,
                                                        style: "header"
                                                    },
                                                    {
                                                        text: `NDC: ${inventoryItem.package}\n`,
                                                        fontSize: 5
                                                    },
                                                    {
                                                        text: `Lot #: ${claimLots
                                                            .map((claimLot) => claimLot.siteLot.lotNumber)
                                                            .join(", ")}`,
                                                        fontSize: 5
                                                    }
                                                ]
                                            },
                                            {
                                                text: [
                                                    {
                                                        text: `${inventoryItem.name}\n`,
                                                        fontSize: 5,
                                                        bold: false
                                                    },
                                                    {
                                                        text: `Generic equivalent of ${inventoryItem.brandNameEquivalent ||
                                                            inventoryItem.name}\n`,
                                                        fontSize: 5
                                                    },
                                                    {
                                                        text: `Manuf: ${inventoryItem.labeler}\n`,
                                                        fontSize: 5
                                                    }
                                                ]
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            },
                            {
                                text: `\n`
                            },
                            {
                                text: [
                                    {
                                        text: `QTY: ${currentClaim.quantity *
                                            inventoryItem.disQty} ${inventoryItem.dosage}`,
                                        fontSize: 5,
                                        style: "header",
                                        bold: true
                                    }
                                ]
                            },
                            {
                                text: [
                                    {
                                        text: `Refills: ${currentClaim.refills -
                                            Number(currentClaim.fillNumber)} before ${moment(orderDate)
                                            .add(1, "year")
                                            .format("MM/DD/YYYY")}`,
                                        fontSize: 5,
                                        style: "header",
                                        bold: true
                                    }
                                ]
                            },
                            {
                                text: `\n`
                            },
                            {
                                table: {
                                    widths: ["*", "*"],
                                    body: [
                                        [
                                            {
                                                text: [
                                                    {
                                                        text: `Prescriber: ${provider.firstName} ${provider.lastName}\n`,
                                                        fontSize: 5,
                                                        bold: true
                                                    },
                                                    {
                                                        text: `Filled By: ${user.firstName[0]}. ${user.lastName}\n`,
                                                        fontSize: 4
                                                    },
                                                    {
                                                        text: `\n*CAUTION – Federal law prohibits the transfer of this drug to any person other than the patient for whom it was prescribed.`,
                                                        fontSize: 4
                                                    }
                                                ]
                                            },
                                            {
                                                text: `Directions for use: ${(inventoryItem.defaultSig &&
                                                    inventoryItem.defaultSig) ||
                                                    "N/A"}${inventoryItem.defaultSig2 &&
                                                    " - " + inventoryItem.defaultSig2}${currentClaim
                                                    .inventory.defaultSig3 &&
                                                    " - " + inventoryItem.defaultSig3}
                              `,
                                                fontSize: 5
                                            }
                                        ]
                                    ]
                                },
                                layout: "noBorders"
                            }
                            // end last table
                        ]
                    }
                ],
                // optional space between columns
                columnGap: 0,
                absolutePosition: { x: 35, y: 40 }
            },
            // Second Row
            {
                columns: [
                    {
                        width: 160,
                        style: "secondRowLeft",
                        stack: [
                            {
                                text: `Rx:${currentClaim.rxId.rxId} ${this.mysqlDateTimeToDate(claimDate)} Refill:${claim.fillNumber} of ${claim.refills || ""}`
                            },
                            { text: `${inventoryItem.defaultSig}` },
                            {
                                text: `${provider.lastName}, ${provider.firstName} ${provider.title || ""}`
                            },
                            {
                                text: `${patient.lastName}, ${patient.firstName} DOB: ${patient.birthDate || ""}`
                            },
                            {
                                text: `NDC: ${inventoryItem.package} Lot: ${claimLots
                                    .map((cLot) => cLot.siteLot.lotNumber)
                                    .join(", ")} ${this.mysqlDateTimeToDate(claimDate)}`
                            },
                            { text: `Manu NDC:${inventoryItem.package || ""}` },
                            {
                                text: `${inventoryItem.name || ""}`
                            }
                        ]
                    },
                    {
                        width: 170,
                        style: { margin: [0, 0, 20, 0] },
                        stack: [
                            {
                                text: `${patient.lastName} ${patient.firstName} ${patient.birthDate || ""}`,
                                fontSize: 6,
                                bold: true,
                                margin: [30, 0, 0, 0]
                            },
                            { image: barcode, width: 100, alignment: "center" }
                        ]
                    },
                    {
                        width: 130,
                        style: "secondRowRight",
                        stack: [
                            {
                                text: `Rx: ${currentClaim.rxId.rxId} ${inventoryItem.package} ${this.orderCreateDate(orderDate)} ${this.orderCreateTime(orderDate)}`
                            },
                            {
                                text: `${inventoryItem.name ||
                                    ""} Lot: ${claimLots
                                    .map((cLot) => cLot.siteLot.lotNumber)
                                    .join(", ")}`
                            },
                            {
                                text: `${patient.lastName} ${patient.firstName} DOB: ${patient.birthDate || ""}`
                            },
                            {
                                text: `Do you require additional counseling for this medication: ${order.reqCounsel ? "YES" : "NO"}`
                            },
                            { text: `Signature:` },
                            {
                                image: patientSignature,
                                width: 100
                                // relativePosition: { x: 75, y: -10 }
                            }
                        ]
                    }
                ],
                absolutePosition: { x: 35, y: 170 }
            },
            // Monograph Section Of Pharmacy Label
            {
                stack: [
                    {
                        text: `Call your doctor for medical advice about side effects. You may report side effects to FDA at 1-800-FDA-1088.
                Patient Information for: ${inventoryItem.name.toUpperCase()} ${inventoryItem.substance ||
                            ""} ${inventoryItem.strengthDescriptionShort || ""}`,
                        alignment: "center",
                        bold: true,
                        fontSize: 7,
                        margin: [0, 20, 0, 0],
                        absolutePosition: { x: 50, y: 260 }
                    },
                    {
                        columns: [
                            {
                                stack: [
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.important) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.ingredients) ||
                                            ""} \n ${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription
                                                .commonBrandNames) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.warning) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.uses) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.howToUse) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.sideEffects) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.precautions) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription
                                                .drugInteractions) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.overdose) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.notes) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.missedDose) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.storage) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    },
                                    {
                                        text: `${(inventoryItem.inventoryItemDescription &&
                                            inventoryItem.inventoryItemDescription.revisionDate) ||
                                            ""}`,
                                        margin: [-20, 5, 0, 0]
                                    }
                                ],
                                fontSize: 5
                            }
                        ],
                        columnGap: 5,
                        absolutePosition: { x: 50, y: 280 },
                        pageBreak
                    }
                ]
            }
        ];
    }
}
exports.PharmacyMakeCali = PharmacyMakeCali;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/pharmacy/locations/california/california.ts
// module id = 2743
// module chunks = 0 1